import React from "react";

import { Shipper } from "../../../../../../../types";
import { ShipperSelectStyle } from "./styles";

interface Props {
  shipper: Shipper;
}

export const ShipperSelect = ({ shipper }: Props) => {
  return (
    <ShipperSelectStyle>
      <span>{shipper?.fullName}</span>
      <span>{shipper?.type}</span>
    </ShipperSelectStyle>
  );
};
